export default "__VITE_ASSET__BrZwDdZ0__"